import { INSTANCE } from './API.js'

export const getWechatBindUrl = () =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'get',
      url: '/auth/wechat/bind/url',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })
